<template>
  <div class="evaluate">
    <div class="evaluate-header">
      <span></span>
      <span>满意度评价</span>
      <z-icon @click="close" color="#999999" size="20px" class-prefix="zziconfont-6" name="close" class="popup-icon"></z-icon>
    </div>
    <div class="evaluate-emotion">
    <div class="item" @click="score(1)">
        <div>
          <img v-show="!isBadSelected" src="https://pic6.zhuanstatic.com/zhuanzh/7d2176c2-edfb-467a-859a-36ca51fc4f23.png" />
          <img v-show="isBadSelected" src="https://pic4.zhuanstatic.com/zhuanzh/e4cecf2f-2b8a-47fd-a3f7-90a29b55177f.png" />
        </div>
        <span>不满意</span>
      </div>
      <div class="item" @click="score(2)">
        <div>
          <img v-show="!isMiddleSelected" src="https://pic4.zhuanstatic.com/zhuanzh/5e3bd875-15f9-4a92-8aea-542fa71cadb8.png" />
          <img v-show="isMiddleSelected" src="https://pic6.zhuanstatic.com/zhuanzh/0680ed1f-3152-41ac-b45a-1e9c1a13f25a.png" />
        </div>
        <span>一般</span>
      </div>
      <div class="item" @click="score(3)">
        <div>
          <img v-show="!isGoodSelected" src="https://pic6.zhuanstatic.com/zhuanzh/89ec7706-6aa5-4d26-8c3f-f6b2e2e676b3.png" />
          <img v-show="isGoodSelected" src="https://pic1.zhuanstatic.com/zhuanzh/02292d0a-8334-4052-b6c6-cddb508c9487.png" />
        </div>
        <span>满意</span>
      </div>
    </div>
    <z-field
      ref="textfield"
      v-model="desc"
      type="textarea"
      :placeholder="placeHolder"
      rows="3"
      autosize
      :maxlength="100"
      count-word
    />
    <z-button-group>
      <z-button size="large" type="primary" :disabled="!this.desc.length" @click="submit">提交评价</z-button>
    </z-button-group>
  </div>
</template>

<script>
import { Button, ButtonGroup, Icon, Field } from '@zz-common/zz-ui'
import { newReportEvaluate } from '@api/resourceApi'
export default {
  name: 'EvaluateComp',
  data() {
    return {
      rank: '', //评价等级
      desc: '', //描述
      placeholdertype: {
        1: '很遗憾没能解决您的问题，请您积极反馈，我们会仔细聆听~',
        2: '说说您认为我们做的不够的地方吧，我们会积极采纳您的反馈~',
        3: '说说您认为很满意的地方吧，您的反馈会让我们变得更好~'
      }
    }
  },
  inject: ['id', 'toUid'],
  computed: {
    isBadSelected() {
      return this.rank == '1'
    },
    isGoodSelected() {
      return this.rank == '3'
    },
    isMiddleSelected() {
      return this.rank == '2'
    },
    placeHolder() {
      return this.placeholdertype[this.rank] || '说说您对我们的评价吧，您的反馈会让我们变得更好~'
    }
  },
  components: {
    zButton: Button,
    zIcon: Icon,
    zField: Field,
    zButtonGroup: ButtonGroup
  },
  methods: {
    score(item) {
      this.$refs.textfield.focus()
      this.rank = item
    },
    close() {
      this.$emit('close')
    },
    async submit() {
      await newReportEvaluate({ appraise: this.rank, content: this.desc, toUid: this.toUid, reportId: this.id })
      this.$toast('提交成功，感谢您的评价')
      this.$emit('close')
      this.$emit('closeevaluate')
    }
  }
}
</script>
<style lang="less" scoped>
 @import 'index.less';
</style>